export const MEMBERSHIP_STRINGS = {
  en: {
    TITLE: 'Choose your membership',
    SIGNUP_IN: 'Sign up in',
    SAVE: 'Save',
    ON: 'on',
    MORE_QUESTIONS: 'Got more questions? Visit our',
    FAQ_LINK: 'FAQ page',
    CAMPAIGN_TERMS: 'Campaign terms',
    CAMPAIGN_TERMS_INTRO:
      'By using a campaign code, the Member accept the following terms:',
    CAMPAIGN_TERMS_LIST: [
      "The very first time the Member purchase a Bruce Studios membership, you can terminate the membership without a notice period within the first 30 days. Because of this, the membership can last a minimum of 1 or 3 months, regardless of the campaign's duration. After the first month, a notice period of 1 month always applies.",
      'Campaigns are only for new members.* Campaigns never apply to individuals with an active or paused membership, or during a trial period. The right to use a campaign code is determined by Bruce Studios at its discretion, and Bruce Studios may limit this right to prevent abuse of campaigns.',
      'No discount codes can be combined with other discounts or offers.',
      'If the Member pauses the membership during the campaign period, the Member risks losing all or part of the discount for the remaining campaign period.',
      "A campaign code must be activated within the campaign's framework, but no later than 25 days after the Member has added it to its user.",
      'The discount always applies to current regular prices during the campaign period, and all discounts are time-limited.',
    ],
    CAMPAIGN_TERMS_READ_MORE:
      "Bruce Studios' general terms also apply to anyone using a campaign. Read them",
    CAMPAIGN_TERMS_READ_MORE_LINK: 'here',
    CAMPAIGN_TERMS_DISCLAIMER:
      '*Exceptions can apply if you have received a personal offer via email or SMS.',
    CAMPAIGN_TERMS_DISMISS: 'Done',
  },
  sv: {
    TITLE: 'Välj ditt medlemskap',
    SIGNUP_IN: 'Registrera dig i',
    SAVE: 'Spara',
    ON: 'på',
    MORE_QUESTIONS: 'Fler frågor? Besök vår',
    FAQ_LINK: 'FAQ-sida',
    CAMPAIGN_TERMS: 'Kampanjvillkor',
    CAMPAIGN_TERMS_INTRO:
      'Om Medlemmen använder sig av en kampanjkod gäller följande villkor:',
    CAMPAIGN_TERMS_LIST: [
      'Första gången Medlemmen någonsin har ett betalande medlemskap i Bruce Studios kan Medlemmen avsluta medlemskapet utan uppsägningstid under de första 30 dagarna. På grund av det kan medlemskapet som minst vara aktivt 1 eller 3 månader oberoende längd på kampanj. Efter första månaden gäller alltid 1 månads uppsägningstid.',
      'Kampanjer gäller endast nya medlemmar*. Kampanjer gäller aldrig personer med aktivt eller pausat medlemskap eller under en Trial-period. Rätten att ta del av en kampanj bestäms av Bruce Studios efter eget gottfinnande och Bruce Studios kan begränsa denna rätt för att förhindra att kampanjer missbrukas.',
      'Inga rabattkoder kan kombineras med andra rabatter eller erbjudanden.',
      'Om Medlemmen pausar under kampanjperioden, riskerar Medlemmen att förlora hela eller delar av rabatten på resterande tid av kampanjen.',
      'En kampanjkod måste aktiveras inom kampanjens ramar men senast 25 dagar från att Medlemmen lagt in den på sin profil.',
      'Rabatten gäller alltid på de aktuella listpriserna för kampanjperioden och alla rabatter är tidsbegränsade.',
    ],
    CAMPAIGN_TERMS_READ_MORE:
      'Bruce Studios allmänna villkor gäller för även för alla som använder sig av en kampanj. Läs dem',
    CAMPAIGN_TERMS_READ_MORE_LINK: 'här',
    CAMPAIGN_TERMS_DISCLAIMER:
      '*Undantag kan gälla om du har fått ett personligt erbjudande via e-post eller SMS.',
    CAMPAIGN_TERMS_DISMISS: 'Klar',
  },
  nb: {
    TITLE: 'Velg ditt medlemskap',
    SIGNUP_IN: 'Registrer deg i',
    SAVE: 'Spar',
    ON: 'på',
    MORE_QUESTIONS: 'Har du flere spørsmål? Besøk vår',
    FAQ_LINK: 'FAQ-side',
    CAMPAIGN_TERMS: 'Kampanjevilkår',
    CAMPAIGN_TERMS_INTRO:
      'Ved å bruke en kampanjekode aksepterer Medlemmet følgende vilkår:',
    CAMPAIGN_TERMS_LIST: [
      'Første gang Medlemmet kjøper et Bruce Studios-medlemskap, kan Medlemmet avslutte medlemskapet uten oppsigelsestid i løpet av de første 30 dagene. På grunn av dette kan medlemskapet vare minimum 1 eller 3 måneder, uavhengig av kampanjens lengde. Etter første måned gjelder alltid en oppsigelsestid på 1 måned.',
      'Kampanjer gjelder kun for nye medlemmer*. Kampanjer gjelder aldri personer med aktivt eller pauseret medlemskap, eller under en prøveperiode. Retten til å benytte en kampanjekode bestemmes av Bruce Studios etter eget skjønn, og Bruce Studios kan begrense denne retten for å forhindre misbruk av kampanjer.',
      'Ingen rabattkoder kan kombineres med andre rabatter eller tilbud.',
      'Hvis Medlemmet setter medlemskapet på pause i løpet av kampanjeperioden, risikerer Medlemmet å miste hele eller deler av rabatten i gjenværende kampanjeperiode.',
      'En kampanjekode må aktiveres innenfor kampanjens rammer, men senest 25 dager etter at Medlemmet har lagt den inn på brukeren sin.',
      'Rabatten gjelder alltid gjeldende ordinære priser i kampanjeperioden, og alle rabatter er tidsbegrenset.',
    ],
    CAMPAIGN_TERMS_READ_MORE:
      'Bruce Studios vilkår og betingelser gjelder også for alle som benytter seg av en kampanje. Les dem',
    CAMPAIGN_TERMS_READ_MORE_LINK: 'her',
    CAMPAIGN_TERMS_DISCLAIMER:
      '*Unntak kan gjelde dersom Medlemmet har mottatt et personlig tilbud på e-post eller tekstmelding.',
    CAMPAIGN_TERMS_DISMISS: 'Ferdig',
  },
  da: {
    TITLE: 'Vælg dit medlemskab',
    SIGNUP_IN: 'Tilmeld dig i',
    SAVE: 'Spar',
    ON: 'på',
    MORE_QUESTIONS: 'Har du flere spørgsmål? Besøg vores',
    FAQ_LINK: 'FAQ side',
    CAMPAIGN_TERMS: 'Kampagnevilkår',
    CAMPAIGN_TERMS_INTRO:
      'Ved at bruge en kampagnekode accepterer Medlemmet følgende vilkår:',
    CAMPAIGN_TERMS_LIST: [
      'Første gang Medlemmet køber et Bruce Studios-medlemskab, kan Medlemmet opsige medlemskabet uden opsigelsesvarsel inden for de første 30 dage. På grund af dette kan medlemskabet vare mindst 1 eller 3 måneder, uafhængigt af kampagnens varighed. Efter den første måned gælder der altid et opsigelsesvarsel på 1 måned.',
      'Kampagner er kun for nye medlemmer* Kampagner gælder aldrig for personer med et aktivt eller pauset medlemskab eller under en prøveperiode. Retten til at benytte en kampagnekode bestemmes af Bruce Studios efter eget skøn og Bruce Studios kan begrænse denne ret for at forhindre misbrug af kampagner.',
      'Ingen rabatkoder kan kombineres med andre rabatter eller tilbud.',
      'Hvis Medlemmet sætter medlemskabet på pause i kampagneperioden, risikerer Medlemmet at miste hele eller en del af rabatten i den resterende kampagneperiode.',
      'En kampagnekode skal aktiveres inden for kampagnens gyldighedsperiode, dog senest 25 dage efter Medlemmet har tilføjet den til sin profil.',
      'Rabatten gælder altid på aktuelle ordinære priser i kampagneperioden og alle rabatter er tidsbegrænsede.',
    ],
    CAMPAIGN_TERMS_READ_MORE:
      "Bruce Studios's generelle vilkår er også gældende for alle, der gør brug af en kampagne. Læs dem",
    CAMPAIGN_TERMS_READ_MORE_LINK: 'her',
    CAMPAIGN_TERMS_DISCLAIMER:
      '*Undtagelser kan gælde, hvis Medlemmet har modtaget et personligt tilbud via e-mail eller SMS.',
    CAMPAIGN_TERMS_DISMISS: 'Færdig',
  },
} as const
